module.exports = __webpack_public_path__ + "img/mff-logo-dark.f687d6c8.png";